// eslint-disable-next-line import/prefer-default-export
export const IdentityStoreEndpoints = {
  local: 'http://localhost:3030/local/v2',
  dev: 'https://dev.api.civic.com/identity-store-dev/v2',
  preprod: 'https://dev.api.civic.com/identity-store-preprod/v2',
  prod: 'https://api.civic.com/identity-store/v2',
};
